import { InventoryItemOutcome } from "@redotech/crdb-enums/inventory/inventory-item-outcome";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { sortDestinationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

const ScanSortingToteResult_ = z.discriminatedUnion("status", [
  z.object({
    status: z.literal("placed"),
    groupName: z.string(),
    toteName: z.string(),
  }),
  z.object({ status: z.literal("confirmed"), locationName: z.string() }),
  z.object({ status: z.literal("wrong_bin") }),
  z.object({ status: z.literal("wrong_tote") }),
  z.object({ status: z.literal("no_totes") }),
  z.object({
    status: z.literal("no_destination"),
    outcome: z.nativeEnum(InventoryItemOutcome).nullable(),
  }),
  z.object({ status: z.literal("not_found") }),
  z.object({
    status: z.literal("needs_destination"),
    toteName: z.string(),
    destinations: z.array(
      z.object({ id: sortDestinationIdFormat.schema, name: z.string() }),
    ),
  }),
]);
export type ScanSortingToteResult = z.infer<typeof ScanSortingToteResult_>;

export const scanSortingTote = {
  name: "scanSortingTote" as const,
  input: z.object({
    identifier: z.string().min(1),
    scannedTote: z.string().min(1),
    locationId: locationIdFormat.schema,
    sortDestinationId: sortDestinationIdFormat.schema.optional(),
  }),
  output: z.object({ result: ScanSortingToteResult_ }),
};
